import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	closeDate: {
		id: 'search-page.filters.names.closeDate',
		defaultMessage: 'Close date',
		description: 'Label for filtering by close date',
	},
});
